const { dayjs } = require('./date');
const { hasModuleLicense } = require('./license');
const {
  COLLECTION_STALE_AFTER_HOURS,
  COLLECTION_STALE_BEFORE_DAYS,
} = require('../constants/collectionActivity');

function getStaleCollectionModules(
  collectionActivity,
  activeLicense,
) {
  return Object.entries(collectionActivity || {}).filter(([module, activity]) => {
    if (!hasModuleLicense(activeLicense, module)) {
      return false;
    }

    if (!activity?.lastActivityTimestamp) {
      return false;
    }

    const lastActivity = dayjs(activity.lastActivityTimestamp);

    return lastActivity.isBefore(dayjs().subtract(COLLECTION_STALE_AFTER_HOURS, 'hour'))
      && lastActivity.isAfter(dayjs().subtract(COLLECTION_STALE_BEFORE_DAYS, 'day'));
  }).map(([module, activity]) => ({ module, activity }));
}

function getActiveCollectionModules(collectionActivity, activeLicense) {
  return Object.entries(collectionActivity || {})
    .filter(([module, activity]) => hasModuleLicense(activeLicense, module)
      && activity?.lastActivityTimestamp && dayjs(activity.lastActivityTimestamp).isAfter(dayjs().subtract(COLLECTION_STALE_AFTER_HOURS, 'hour')))
    .map(([module, activity]) => ({ module, activity }));
}

module.exports = {
  getStaleCollectionModules,
  getActiveCollectionModules,
};
